import {StyleSheet} from "aphrodite/no-important"

export const styles = StyleSheet.create({
    content: {
        display: "grid",
    },
    loginContainer: {
        position: "absolute",
        top:"50%",
        left:"50%",
        transform: "translate(-50%,-50%)",
        display: "grid",
        gridTemplateRows: "min-content min-content min-content min-content",
        gridTemplateRowGap: "10px",
        minWidth: "250px"
    },
    submitButton: {
        margin: "10px",
        marginLeft: 'auto',
        marginRight: "auto"
    }
});


// WEBPACK FOOTER //
// ./src/pages/LoginPageStyle.ts